export function TerminosPage() {
  return (
    <section className="px-4 sm:px-6 md:px-14 py-10 md:py-16 max-w-2xl mx-auto flex flex-col gap-5">
      <h1 className="text-4xl font-display font-semibold text-wood">Términos y Condiciones</h1>
      <p className="text-[14px] leading-relaxed text-ink-muted">
        Al realizar un pedido en Santtesanía, aceptas que el pago y la entrega se coordinan directamente
        con nuestro equipo por WhatsApp tras confirmar tu carrito. Los precios mostrados en el
        catálogo están sujetos a disponibilidad de stock al momento de la confirmación del pedido.
      </p>
      <p className="text-[14px] leading-relaxed text-ink-muted">
        Los precios por paquete (docena, medio ciento, ciento) son definidos por producto y pueden
        variar sin previo aviso; el precio aplicado a tu pedido es el vigente al momento de
        confirmarlo.
      </p>
      <p className="text-[14px] leading-relaxed text-ink-muted">
        Para cualquier consulta sobre un pedido ya realizado, contáctanos por WhatsApp indicando tu
        nombre y número de pedido.
      </p>
    </section>
  );
}
